import React, { useEffect, useState } from "react";
import { Button, Card, CardBody } from "reactstrap";
import { Link } from "react-router-dom";
import TopHeader from "components/TopHeader/topHeader";
import { useCookies } from "react-cookie";
import PaginationComponent from "components/Pagination/Pagination";
import useApi from "../../../apiHooks/apiHooks";
import TableCompany from "components/Table/TableCompany";
import NoData from "components/Others/NoData";

export default function Companies() {
    const [cookies, setCookie] = useCookies();
    const [company, setCompany] = React.useState(null);
    const header = ["Company", "Email", "Options"];
    const { getAllCompanies } = useApi();

    // Pagination
    const itemLimit = 10;
    const [dataShown, setDataShown] = useState(null);
    const [dataLength, setDataLength] = useState(0);
    const [numOfPages, setNumOfPages] = useState(1);
    const [initialCount, setInitialCount] = useState(0);
    const [page, setPage] = useState(1);

    const handlePageChange = (newPage) => {
        const from = newPage * itemLimit;
        const until = from + itemLimit;
        setDataShown(company.slice(from, until));
        setPage(newPage + 1);
        setInitialCount(newPage * itemLimit);
    };

    const handlePrevious = () => {
        const from = initialCount - itemLimit;
        const until = from + itemLimit;
        if (page > 1) {
            setDataShown(company.slice(from, until));
            setPage(page - 1);
            setInitialCount(initialCount - itemLimit);
        }
    };

    const handleNext = () => {
        const from = initialCount + itemLimit;
        const until = from + itemLimit;
        if (page < numOfPages) {
            setDataShown(company.slice(from, until));
            setPage(page + 1);
            setInitialCount(initialCount + itemLimit);
        }
    };

    const getCompanies = async () => {
        let headers = {
            headers: {
                "auth-token": cookies.userToken,
            },
        };
        try {
            const response = await getAllCompanies(headers);
            const companies = response.data.companies;
            setCompany(companies);
            setDataLength(companies.length);
            setDataShown(companies.slice(0, itemLimit));
            // console.log(response.data);
        } catch (err) {
            const error = err.response;
            console.log(`err`, error);
        }
    };
    useEffect(() => {
        getCompanies();
    }, []);

    useEffect(() => {
        if (dataLength > 0) setNumOfPages(dataLength / itemLimit);
    }, [dataLength]);

    // Search Bar
    const [searchedData, setSearchedData] = useState(null);
    useEffect(() => {
        setSearchedData(dataShown);
    }, [dataShown]);

    const onSearch = (event) => {
        let keyword = event.target.value.toLowerCase();
        setSearchedData(
            company?.filter((row) => {
                return (
                    row.name.toLowerCase().includes(keyword) ||
                    row.email.toLowerCase().includes(keyword)
                );
            })
        );
    };

    // Page Number Button Component
    let pageNumbers = [];
    for (var i = 0; i < numOfPages; i++) {
        pageNumbers.push(i);
    }

    // Styles
    const styles = {
        button: {
            backgroundColor: "#01497C",
            color: "white",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            float: "left",
        },
    };
    return (
        <div className="m-5">
            <TopHeader title="Companies" searchBar onChange={onSearch} />
            <Card className="my-5">
                <CardBody>
                    <Link to="/admin/companies/create">
                        <Button style={styles.button} type="button">
                            <span className="btn-inner--icon">
                                <i
                                    className="ni ni-fat-add"
                                    style={{ fontSize: 20 }}
                                />
                            </span>
                            <span className="btn-inner--text">Create New</span>
                        </Button>
                    </Link>

                    <TableCompany header={header} searchedData={searchedData} />

                    {searchedData?.length < 1 && (
                        <NoData text="No Companies Found" />
                    )}

                    <div className="mt-5">
                        <PaginationComponent
                            page={page}
                            handlePrevious={handlePrevious}
                            handleNext={handleNext}
                            handlePageChange={handlePageChange}
                            numOfPages={numOfPages}
                            pageNumbers={pageNumbers}
                        />
                    </div>
                </CardBody>
            </Card>
        </div>
    );
}
